import axios from "../utils/axios";

export const customerShopRegistration = async (req) => {
  const response = await axios.post("/api/Payment/NewSubscriptionPayment", req);
  //console.log(response);
  return response.data;
};


export const getUserShopInformation = async (req) => {
 const response = await axios.get(`/api/User/GetCompanySetting`, {
    headers: {
        Authorization: "Bearer " + localStorage.getItem("serviceToken"),
    }
  });

  //const response = await axios.get("/api/User/GetCompanySetting");
  //console.log(response);
  return response.data;
};

export const getStoreInformation = async (storeid) => {
 
   const response = await axios.get("/api/Company/GetSingleItem", {
      params: { id: storeid },
       headers: {
        Authorization: "Bearer " + localStorage.getItem("serviceToken"),
      }
    });
 
  return response.data;
};